var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlFilledThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 33,
    viewBox: "0 0 36 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9842 5.8498C19.6022 5.8498 20.9138 4.54027 20.9138 2.9249C20.9138 1.30952 19.6022 0 17.9842 0C16.3663 0 15.0547 1.30952 15.0547 2.9249C15.0547 4.54027 16.3663 5.8498 17.9842 5.8498Z",
    fill: "#D2AE5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0702 10.8576C34.6881 10.8576 35.9997 9.54809 35.9997 7.93271C35.9997 6.31733 34.6881 5.00781 33.0702 5.00781C31.4522 5.00781 30.1406 6.31733 30.1406 7.93271C30.1406 9.54809 31.4522 10.8576 33.0702 10.8576Z",
    fill: "#D2AE5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.92954 10.8576C4.54748 10.8576 5.85908 9.54809 5.85908 7.93271C5.85908 6.31733 4.54748 5.00781 2.92954 5.00781C1.3116 5.00781 0 6.31733 0 7.93271C0 9.54809 1.3116 10.8576 2.92954 10.8576Z",
    fill: "#D2AE5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.4518 9.84927C33.5589 9.31777 33.3111 8.77959 32.8407 8.51217C32.3687 8.24642 31.7777 8.31161 31.376 8.67596C31.376 8.67596 29.6249 10.2654 27.6496 12.0588C26.7255 12.8978 25.4449 13.2238 24.2312 12.9313C23.0176 12.6388 22.0282 11.7647 21.5896 10.5964L19.1673 4.14989C18.9832 3.66018 18.5161 3.33594 17.9922 3.33594C17.4682 3.33594 17.0011 3.66018 16.817 4.14989L14.3947 10.5964C13.9561 11.7647 12.9667 12.6388 11.7531 12.9313C10.5394 13.2238 9.25877 12.8978 8.33471 12.0588C6.35936 10.2654 4.60833 8.67596 4.60833 8.67596C4.20657 8.31161 3.61564 8.24642 3.14356 8.51217C2.67316 8.77959 2.42541 9.31777 2.53255 9.84927C2.53255 9.84927 4.39573 19.1504 5.34156 23.8754C5.77178 26.0248 7.66175 27.5708 9.8564 27.5708H26.1279C28.3226 27.5708 30.2125 26.0248 30.6427 23.8754C31.5886 19.1504 33.4518 9.84927 33.4518 9.84927Z",
    fill: "#D2AE5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0391 30.0898H7.95083C7.25778 30.0898 6.69531 30.6514 6.69531 31.3434C6.69531 32.0353 7.25778 32.5969 7.95083 32.5969H28.0391C28.7322 32.5969 29.2946 32.0353 29.2946 31.3434C29.2946 30.6514 28.7322 30.0898 28.0391 30.0898Z",
    fill: "#D2AE5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlFilledThree);
export default __webpack_public_path__ + "static/media/al-filled-three.8bee99fe281f0da2c556fe898e89353f.svg";
export { ForwardRef as ReactComponent };